import {
  select,
  max,
  scaleLinear,
  interpolateRgb,
  geoMercator,
  geoPath,
  event,
  axisBottom,
} from "d3";
import { textactive } from "@/_core/_helpers/_parametric_tools";
/**
 *
 * @param {*} _parentElement
 * @param {*} _childElement
 * @param {*} _context
 */
export const WorldChart = function(_parentElement, _childElement, _context) {
  this.parentElement = _parentElement;
  this.childElement = _childElement;
  this.context = _context;
};
/**
 *
 * @param {*} _worldFeaturesData
 * @param {*} _worldDataById
 * @param {*} _worldIndexById
 * @param {*} _worldCoordinates
 * @param {*} _colorSelection
 * @param {*} _pickedTimeframe
 */

WorldChart.prototype.initVis = function(
  _worldFeaturesData,
  _worldDataById,
  _worldIndexById,
  _worldCoordinates,
  _colorSelection,
  _pickedTimeframe,
) {
  var vis = this;
  vis.sharp = "#";
  select(`${vis.sharp}${vis.parentElement}`)
    .select("svg > *")
    .remove();
  vis.chartDiv = document.getElementById(vis.parentElement);
  vis.width = vis.chartDiv.clientWidth;
  vis.height = vis.chartDiv.clientHeight;
  vis.margin = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
  vis.width = vis.width - vis.margin.left - vis.margin.right;
  vis.height = vis.height - vis.margin.top - vis.margin.bottom;
  vis.data = _worldFeaturesData;
  vis.worldById = _worldDataById;
  vis.worldIdxById = _worldIndexById;
  vis.coordinates = _worldCoordinates;
  vis.colorSelection = _colorSelection;
  vis.tframe = _pickedTimeframe;
  vis.limit = max(vis.data.features, function(d) {
    return Math.abs(vis.worldById[d.id]);
  });
  vis.colorLimits = [
    -vis.limit,
    -vis.limit * 0.5,
    0,
    vis.limit * 0.5,
    vis.limit,
  ];

  vis.screenSize = document.getElementById("whole-page-div");
  // Data and color scale
  vis.color = scaleLinear()
    .domain(vis.colorLimits)
    .range(vis.colorSelection)
    .interpolate(interpolateRgb); //interpolateHsl interpolateHcl interpolateRgb;

  // Map and projection
  vis.projection = geoMercator()
    .scale(vis.width * 0.17)
    .translate([vis.width / 2.2, vis.height / 1.6]);
  vis.path = geoPath().projection(vis.projection);

  return vis.color;
};

/**
 * @param {*} _formatPercent
 */

WorldChart.prototype.tooltip = function(
  _formatPercent,
  svg,
  lineWidth = 2,
  fontColor,
  color,
  svgRelat,
  logo,
) {
  var vis = this;
  vis.Tooltip = select(`${vis.sharp}${vis.parentElement}`)
    .append("div")
    .style("opacity", 0)
    .attr("class", "tooltip")
    .style("font-size", "1rem");

  vis.formatPercent = _formatPercent;
  // create SVG and translate
  vis.svg = select(`${vis.sharp}${vis.childElement}`)
    .attr("width", vis.width + vis.margin.left + vis.margin.right)
    .attr("height", vis.height + vis.margin.top + vis.margin.bottom)
    .append("g")
    .attr("class", "map");

  let logoSize = 50;
  let offst = 20;
  let yPos = 2 * offst;
  let xPos = logoSize + offst;
  vis.svg
    .append("image")
    .attr("xlink:href", logo)
    .attr("x", vis.width - xPos + "px")
    .attr("y", yPos)
    .attr("width", logoSize + "px")
    .attr("height", logoSize + "px")
    .style("opacity", 0.3);

  // // Draw the map
  vis.svg
    .append("g")
    .attr("class", "countries")
    .selectAll("path")
    .classed("hoved", true)
    .data(vis.data.features)
    .enter()
    .append("path")
    .attr("d", vis.path)
    .attr("id", function(d) {
      return d.id;
    })
    .style("fill", function(d) {
      return Number.isFinite(vis.worldById[d.id])
        ? vis.color(vis.worldById[d.id])
        : "rgba(0,0,0,0)";
    })
    .on("mouseover", function(d) {
      event.preventDefault();

      let i, ret, base, relat;
      svgRelat.hBar.attr("stroke", function(dat) {
        for (i = 0; i < dat.length; i++) {
          if (dat[i].currency !== d.currency) {
            select(".hbarCURRREL" + dat[i].currency).classed("notHoved", true);
            relat =
              vis.worldIdxById[d.id] === undefined
                ? "N.A"
                : vis.worldIdxById[d.id].length > 0
                ? vis.worldIdxById[d.id].slice(0, 3) === "USD"
                  ? vis.worldIdxById[d.id].slice(-3)
                  : vis.worldIdxById[d.id].slice(0, 3)
                : "N.A";
          } else {
            ret = dat[i].x;
            base = dat[i].name.slice(0, 3);
            relat =
              dat[i].currency.slice(0, 3) === "USD"
                ? dat[i].currency.slice(-3)
                : dat[i].currency.slice(0, 3);
          }
        }
      });
      select(".hbarCURRREL" + d.currency).classed("hoved", true);

      let txt;
      if (isFinite(d.chartData)) {
        if (ret === undefined) {
          txt =
            "<span style='color:var(--expo)'>" +
            d.properties.name.toUpperCase() +
            ":</span>" +
            "<span> " +
            vis.worldIdxById[d.id] +
            "<br></span>" +
            relat +
            "/USD CHANGE: <span><strong>" +
            vis.formatPercent(d.chartData) +
            "</span></strong>";
        } else {
          txt =
            "<span style='color:var(--expo)'>" +
            d.properties.name.toUpperCase() +
            ":</span>" +
            "<span> " +
            vis.worldIdxById[d.id] +
            "<br></span>" +
            relat +
            "/USD CHANGE: <span><strong>" +
            vis.formatPercent(d.chartData) +
            "</span></strong><br>" +
            base +
            "/" +
            relat +
            " CHANGE: <span><strong>" +
            vis.formatPercent(ret) +
            "</span></strong>";
        }
      } else {
        txt =
          "<strong><span style='color:var(--expo)'>" +
          d.properties.name.toUpperCase() +
          "<br></span></strong>";
      }

      vis.Tooltip.style("opacity", 1)
        .style("width", "auto")
        .html(txt)
        .style(
          "left",
          event.layerX -
            100 +
            (100 * (40 - vis.coordinates[d.id][1])) / 140 +
            "px",
        )
        .style("top", event.layerY + 15 + "px");

      select(this).classed("hoved", true);
      if (isFinite(vis.worldById[d.id])) {
        vis.focus.style("display", null);
        vis.focus
          .select(".x-hover-line-world")
          .attr(
            "x1",
            vis.width * (0.5 + (0.4 * vis.worldById[d.id]) / vis.limit),
          );
        vis.focus
          .select(".x-hover-line-world")
          .attr(
            "x2",
            vis.width * (0.5 + (0.4 * vis.worldById[d.id]) / vis.limit),
          );
      }

      svg.sortlines1.style("stroke-width", function(dat) {
        return dat.name === d.currency ? lineWidth : 0.2;
      });
      svg.sortlines2.style("stroke-width", function(dat) {
        return dat.name === d.currency ? lineWidth : 0.2;
      });
      svg.sortlines3.style("stroke-width", function(dat) {
        return dat.name === d.currency ? lineWidth : 0.2;
      });
      svg.legendsB.attr("stroke", function(dat) {
        return dat.aux_name === d.currency ? textactive : null;
      });
      svg.legendsT.style("fill", function(dat) {
        return dat.aux_name === d.currency ? textactive : fontColor;
      });
    })

    /* debe desaparecer en commodities */

    .on("mouseout", function(d) {
      vis.Tooltip.style("opacity", 0)
        .classed("hoved", false)
        .html("");

      select(this).classed("hoved", false);
      vis.focus.style("display", "none");

      svg.sortlines1.style("stroke-width", lineWidth);
      svg.sortlines2.style("stroke-width", lineWidth);
      svg.sortlines3.style("stroke-width", lineWidth);
      svg.legendsB.attr("stroke", function(dat) {
        return color(isFinite(dat.value) ? dat.value : 0);
      });
      svg.legendsT.style("fill", fontColor);
      let i;

      svgRelat.hBar.attr("stroke", function(dat) {
        for (i = 0; i < dat.length; i++) {
          select(".hbarCURRREL" + dat[i].currency).classed("notHoved", false);
        }
      });
      select(".hbarCURRREL" + d.currency).classed("hoved", false);
    });
};

WorldChart.prototype.gradientBar = function() {
  var vis = this;
  // Gradient Bar
  vis.legend = vis.svg
    .append("defs")
    .append("svg:linearGradient")
    .attr("id", "gradientCurrencies")
    .attr("x1", "0%")
    .attr("y1", "100%")
    .attr("x2", "100%")
    .attr("y2", "100%")
    .attr("spreadMethod", "pad");

  vis.legend
    .append("stop")
    .attr("offset", 0)
    .attr("stop-color", vis.colorSelection[0])
    .attr("stop-opacity", 1);
  vis.legend
    .append("stop")
    .attr("offset", 1 / 4)
    .attr("stop-color", vis.colorSelection[1])
    .attr("stop-opacity", 1);
  vis.legend
    .append("stop")
    .attr("offset", 2 / 4)
    .attr("stop-color", vis.colorSelection[2])
    .attr("stop-opacity", 1);
  vis.legend
    .append("stop")
    .attr("offset", 3 / 4)
    .attr("stop-color", vis.colorSelection[3])
    .attr("stop-opacity", 1);
  vis.legend
    .append("stop")
    .attr("offset", 4 / 4)
    .attr("stop-color", vis.colorSelection[4])
    .attr("stop-opacity", 1);

  vis.svg
    .append("rect")
    .attr("width", vis.width * 0.8)
    .attr("height", vis.height * 0.025)
    .style("fill", "url(#gradientCurrencies)")
    .attr(
      "transform",
      "translate(" + vis.width * 0.1 + ", " + vis.height * 0.9 + ")",
    );

  vis.y = scaleLinear()
    .range([vis.width * 0.8, 0])
    .domain([vis.limit, -vis.limit]);

  vis.yAxis = axisBottom()
    .scale(vis.y)
    .tickSize(-vis.width * 0.025)
    .tickFormat(vis.formatPercent)
    .ticks(10);

  vis.svg
    .append("g")
    .attr("class", "y axis")
    .attr(
      "transform",
      "translate(" + vis.width * 0.1 + ", " + vis.height * 0.925 + ")",
    )
    .call(vis.yAxis);

  vis.focus = vis.svg
    .append("g")
    .attr("class", "focus")
    .style("display", "none");

  // line that appears on the color bar
  vis.focus
    .append("line")
    .attr("class", "x-hover-line-world hover-line-world")
    .attr("y1", vis.height * 0.895)
    .attr("y2", vis.height * 0.925)
    .attr("x1", vis.width / 2)
    .attr("x2", vis.width / 2)
    .style("stroke-width", "2px")
    .style("stroke", textactive);

  // // chart sub title
  vis.svg
    .append("g")
    .append("text")
    .attr("y", 0)
    .attr("dy", "0em")
    .attr("class", "axis-sub-title")
    .attr("transform", "translate(50, 50)")
    .style("text-anchor", "left")
    .style("font-size", "1rem")
    .text(vis.tframe + " change: " + this.context.chartDateRange);
};
